
export const products = [
    {
        id: 1,
        img:"https://github.com/maarvins/buscador/raw/master/src/assets/print.png",
        title:"Buscador de Cep",
        link: "https://buscador-bice.vercel.app/",
        repository:"https://github.com/maarvins/buscador"
    },
    {
        id: 2,
        img:"https://raw.githubusercontent.com/maarvins/onScroll-landingPage/master/src/assets/print.png",
        title:"On Scroll Effect",
        link:"https://on-scroll-landing-page.vercel.app/",
        repository: "https://github.com/maarvins/onScroll-landingPage"
    },
    {
        id: 3,
        img:"https://raw.githubusercontent.com/maarvins/finances/master/src/assets/print.png",
        title:"Finances App",
        // link:"https://finances-liard.vercel.app/", // NECESSÁRIO TORNAR RESPONSIVO
        repository: "https://github.com/maarvins/finances"
    },
    {
        id:4,
        img:"https://github.com/maarvins/calculator-js/raw/master/assets/calculator-js.png",
        title:"Calculator",
        link:"https://maarvins.github.io/calculator-js/",
        repository:"https://github.com/maarvins/calculator-js"
    },
    {
        id: 5,
        img:"https://github.com/maarvins/login/raw/master-branch/login-view.png",
        title:"Login View",
        // link:"https://maarvins.github.io/login/", // NECESSÁRIO TORNAR RESPONSIVO
        repository: "https://github.com/maarvins/login"
    },
    {
        id: 6,
        img:"https://github.com/maarvins/Clone-instagram/raw/master/public/assets/print-app.png",
        title:"Instagram Clone",
        link:"https://clone-instagram-olive.vercel.app/",
        repository: "https://github.com/maarvins/Clone-instagram"
    }
]